/* Copyright (c) 2026 PearlCrm Pty Ltd. All rights reserved. */

/** Label-over-value pair inside an InfoCard grid. */

import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import MDTypography from "components/MDTypography";

export default function DetailField({ label, value, xs, md }) {
  return (
    <Grid item xs={xs} md={md}>
      <MDTypography variant="caption" color="text" fontWeight="medium" display="block" mb={0.5}>
        {label}
      </MDTypography>
      <MDTypography variant="button" fontWeight="regular" color="dark">
        {/* An em dash rather than blank: a missing value should look
            deliberate, not like a rendering failure. */}
        {value || "—"}
      </MDTypography>
    </Grid>
  );
}

DetailField.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node,
  xs: PropTypes.number,
  md: PropTypes.number,
};

DetailField.defaultProps = { value: null, xs: 12, md: 4 };
